module.exports = __webpack_public_path__ + "media/images/faramia/piek-33878ced2b52e917fd76553629e41337.png";